import Layout from "../../hoc/getStartedLayout";
import RegistrationContent from "../../components/getStarted/registration";
import { withRouter } from 'next/router';
import { getAllPrograms, getAllHeardSources } from '../../api/register';

function Register(props) {
	const meta = {
		title: "Register | Bayan",
		description: "Sign Up for Bayan",
		route: "register",
	}
	return (
		<>
			<Layout theme={props.theme} meta={meta}>
				<RegistrationContent router={props.router} programs={props.programs} sources={props.heardSources} />
			</Layout>
		</>
	);
}

export async function getStaticProps() {
	// You can use any data fetching library
	const programs = await getAllPrograms();
	const heardSources = await getAllHeardSources();
	return {
		props: {
			programs: programs || null,
			heardSources: heardSources || null,
		},
	}
}

export default withRouter(Register);
